import { defineMessages } from 'react-intl';

export const messages: {
	consentMessageHistoryCheckboxLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackTextAreaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackTextAreaPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	consentMessageHistoryCheckboxLabel: {
		id: 'ai-mate.feedback-collector.consent-message-history-checkbox-label',
		defaultMessage:
			"Share this and 5 previous messages to Rovo in your feedback. We'll remove any sensitive data.",
		description:
			'Label for the checkbox where user gives consent to include messages from the conversation',
	},
	feedbackTextAreaLabel: {
		id: 'ai-mate.feedback-collector.share-thoughts-label',
		defaultMessage: 'Summary',
		description: 'Label for the textarea where users share their thoughts',
	},
	feedbackTextAreaPlaceholder: {
		id: 'ai-mate.feedback-collector.share-thoughts-placeholder',
		defaultMessage: "Let us know what's on your mind",
		description: 'Placeholder text for the textarea where users share their thoughts',
	},
});
